var _title, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16px",
  height: "16px",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Atom/Icon/System/menu/Exit")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "15 1.06065556 13.9392944 1.77635684e-15 7.5 6.43929443 1.06065556 1.77635684e-15 -1.42108547e-14 1.06065556 6.43929443 7.5 -1.42108547e-14 13.9392944 1.06065556 15 7.5 8.56065556 13.9392944 15 15 13.9392944 8.56065556 7.5"
})));
export { SvgClose as ReactComponent };